import React from "react";

export default function AboutPage() {
  return (
    <div className="max-w-4xl mx-auto px-6 md:px-10 py-16">
      <div className="text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground">About SSR Innovations</div>
      <h1 className="mt-2 font-heading font-medium text-5xl sm:text-7xl tracking-tighter leading-none">Design is<br />an obsession.</h1>
      <p className="mt-8 text-lg text-muted-foreground max-w-2xl leading-relaxed">
        SSR Innovations exists at the intersection of technology and lifestyle. We craft accessories with the same care and precision as the devices they complement — nothing more, nothing less. Every product is engineered to feel inevitable in your hand and disappear into your life.
      </p>
      <div className="mt-16 grid md:grid-cols-3 gap-6">
        {[
          { n: "40K+", l: "Happy customers" },
          { n: "120", l: "Products shipped" },
          { n: "4.9★", l: "Avg. rating" },
        ].map((s, i) => (
          <div key={i} className="p-8 rounded-2xl border border-border">
            <div className="font-heading font-medium text-5xl tracking-tighter">{s.n}</div>
            <div className="mt-2 text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground">{s.l}</div>
          </div>
        ))}
      </div>
      <div className="mt-16 space-y-6 text-base leading-relaxed">
        <p>Born in 2024, SSR was founded on a simple belief: the accessories that touch your devices should be as considered as the devices themselves. From the first phone case sketch to the latest wireless earbuds, we obsess over materials, proportions, and the small joyful moments of use.</p>
        <p>Our team of designers, engineers, and product perfectionists works out of studios in Bangalore. We ship worldwide and back every product with a 2-year warranty.</p>
      </div>
    </div>
  );
}
